import { Injectable, Injector } from '@angular/core';
import { BaseResourceOnlineService } from './base-resource/base-resource-online.service';

@Injectable({
  providedIn: 'root'
})
export class VersionService extends BaseResourceOnlineService {
  constructor(
    protected override injector: Injector
  ) {
    super(injector, 'versions');
  }
}
